module.exports = __webpack_public_path__ + "img/2.6919af8b.png";